export enum FileExtension {
  Csv = '.csv',
  Png = '.png',
  Jpg = '.jpg',
  Pdf = '.pdf',
}
